import { Injectable, computed, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'
import { ProjectorsFacade } from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.facade'
import { PresenterContextService } from './gb-presenter-context/presenter-context.service'

export const DEFAULT_TEST_COLORS: Record<string, string> = {
  primary_color: '#FF7A6B',
  background_color: '#3AB4FF',
  accent_color: '#FFD700',
  banner_background_color: '#39A065',
  warning_color: '#F44336',
  success_color: '#26C6DA',
}

@Injectable({
  providedIn: 'root',
})
export class GbPresenterColorResolverService {
  readonly auction
  readonly testColors = signal<Record<string, string>>({ ...DEFAULT_TEST_COLORS })
  private readonly selectedProjector = toSignal(this.projectorsFacade.selectedProjectors$)
  readonly globalFontFamily = computed(() => this.selectedProjector()?.font_family || '')
  readonly resolvedGlobalColor = computed(() => this.resolve(this.selectedProjector()?.color))

  constructor(
    private selectedAuctionFacade: SelectedAuctionFacade,
    private presenterContextService: PresenterContextService,
    private projectorsFacade: ProjectorsFacade,
  ) {
    this.auction = toSignal(this.selectedAuctionFacade.auction$)
  }

  resolve(color: string | null | undefined): string {
    if (!color) return ''
    const auction = this.auction()
    const tokens: Record<string, string> = this.presenterContextService.isTemplateMode
      ? this.testColors()
      : {
          primary_color: auction?.primary_color ?? '',
          background_color: auction?.background_color ?? '',
          accent_color: auction?.accent_color ?? '',
          banner_background_color: auction?.banner_background_color ?? '',
          warning_color: auction?.warn_color ?? '',
          success_color: auction?.success_color ?? '',
        }
    return Object.prototype.hasOwnProperty.call(tokens, color) ? tokens[color] : color
  }

  updateTestColor(token: string, value: string): void {
    this.testColors.update((colors) => ({ ...colors, [token]: value }))
  }
}
